<div class="bg-[#0A0E1F] mx-auto container text-white font-sans pt-0 px-6 md:px-12 lg:px-20 lg:items-center">
  <div class="mx-auto flex flex-col lg:flex-row justify-between gap-[10] lg:items-center align-center">
    <div class="space-y-3 lg:space-x-2 text-center lg:text-start" *ngIf="isHeadingShown">
      <h3 class="font-libre font-bold text-[22px] leading-[27px]">
        <span class="text-[#19E4E0] border-b-2 border-[#19E4E0] pb-[0.05rem]">Spin now</span>
        <span class="text-white"> on Elite Gaming</span>
      </h3>

      <h1 class="text-2xl md:text-3xl font-bold mt-2">
        Spin &amp; Collect Tokens with <br class="hidden md:block" />
        Our Daily Wheel!
      </h1>

      <p class="font-libre font-medium text-[16px] leading-[19px] text-[#A6B1C2] max-w-[607px]">
        Test your strategy on the daily bonus spinner—choose your zone, hit the spin
        button, and watch the wheel reveal exciting game boosts. Every spin brings
        you closer to your next epic milestone!
      </p>
    </div>

    <div class="relative bg-[#0A0E1F] flex justify-center lg:justify-end py-6">
      <div class="relative">
        <img src="/Images/spinner.png" alt="Spinner Preview"
          class="spinner-image w-[350px] sm:w-[450px] lg:w-[600px] xl:w-[700px]" />
        <button
          class="spin-now-btn absolute top-[37%] sm:top-[41%] left-[51.5%] transform -translate-x-1/2 translate-y-[87%]">
          <span class="btn-text text-sm sm:text-base sm:mb-0" (click)="openLoginModal()">
            Spin Now!
          </span>
        </button>
      </div>
    </div>


    </div>
</div>